<template>
  <action-dialog
    :type="type"
    :callback="callback"
    :title="title"
    :message="message"
    :cancel-button-text="cancelButtonText"
    :confirm-button-text="confirmButtonText"
    :dangerously-use-h-t-m-l-string="dangerouslyUseHTMLString"
    @action="handleAction"
  >
    <template slot="footer-left">
      <el-checkbox v-model="userOptDontShow">{{ i18n.t('common.dont_show_again_warning') }}</el-checkbox>
    </template>
  </action-dialog>
</template>
<script>
import i18n from '@/i18n';
import ActionDialog from '@/components/ActionDialog';
export default {
  components: {
    ActionDialog
  },
  data() {
    return {
      callback: null,
      options: {},
      type: undefined,
      title: undefined,
      message: undefined,
      cancelButtonText: undefined,
      confirmButtonText: undefined,
      dangerouslyUseHTMLString: false,
      userOptDontShow: false,
      notificationCode: undefined,
      i18n
    };
  },
  methods: {
    async saveDontShowNotification() {
      const store = (await import('@/store/index.ts')).default;
      store.dispatch('notify/persistBlockNotification', this.notificationCode).catch(err => console.log(err));
    },
    handleAction(action) {
      if (action === 'confirm' && this.userOptDontShow) {
        this.saveDontShowNotification();
      }
    }
  }
};
</script>
